export var IdCursor;
(function (IdCursor) {
    IdCursor["Auto"] = "auto";
    IdCursor["Default"] = "default";
    IdCursor["None"] = "none";
    IdCursor["ContextMenu"] = "context-menu";
    IdCursor["Help"] = "help";
    IdCursor["Pointer"] = "pointer";
    IdCursor["Progress"] = "progress";
    IdCursor["Wait"] = "wait";
    IdCursor["Cell"] = "cell";
    IdCursor["Crosshair"] = "crosshair";
    IdCursor["Text"] = "text";
    IdCursor["VerticalText"] = "vertical-text";
    IdCursor["Alias"] = "alias";
    IdCursor["Copy"] = "copy";
    IdCursor["Move"] = "move";
    IdCursor["NoDrop"] = "no-drop";
    IdCursor["NotAllowed"] = "not-allowed";
    IdCursor["EResize"] = "e-resize";
    IdCursor["NResize"] = "n-resize";
    IdCursor["NeResize"] = "ne-resize";
    IdCursor["NwResize"] = "nw-resize";
    IdCursor["SResize"] = "s-resize";
    IdCursor["SeResize"] = "se-resize";
    IdCursor["SwResize"] = "sw-resize";
    IdCursor["WResize"] = "w-resize";
    IdCursor["EwResize"] = "ew-resize";
    IdCursor["NsResize"] = "ns-resize";
    IdCursor["NeswResize"] = "nesw-resize";
    IdCursor["NwseResize"] = "nwse-resize";
    IdCursor["ColResize"] = "col-resize";
    IdCursor["RowResize"] = "row-resize";
    IdCursor["AllScroll"] = "all-scroll";
    IdCursor["ZoomIn"] = "zoom-in";
    IdCursor["ZoomOut"] = "zoom-out";
    IdCursor["Grab"] = "grab";
    IdCursor["Grabbing"] = "grabbing";
})(IdCursor || (IdCursor = {}));



//////////////////
// WEBPACK FOOTER
// ./src/events/IdCursor.ts
// module id = 426
// module chunks = 3